import React from 'react';
import classNames from 'classnames';
import { Cell } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/Cell';
import { IStudioCellProps } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/StudioCell/type';
import './index.scss';

import CompanyDefault from '@/pages/home/assets/img/common/company-default.svg';

/**
 * StudioCell 组件
 * 渲染：Studio icon + Studio 名称
 */
export const StudioCell = (props: IStudioCellProps) => {
  const { className, style, record, config } = props;
  const {
    iconKey = 'studioIcon',
    nameKey = 'studioName',
    column,
  } = config ?? {};

  const iconUrl = record?.[iconKey] as string | undefined;
  const studioName = record?.[nameKey] as string | undefined;

  return (
    <Cell className={classNames('dbd-common-table__studio-cell', className)} style={style} config={{ column }}>
      <span className="dbd-common-table__studio-cell__inner">
        {iconUrl ? (
          <img
            className="dbd-common-table__studio-cell__icon"
            src={iconUrl}
            alt=""
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = CompanyDefault;
            }}
          />
        ) : (
          <img className="dbd-common-table__studio-cell__icon" src={CompanyDefault} alt="" />
        )}
        <span className="dbd-common-table__studio-cell__name">{studioName ?? '-'}</span>
      </span>
    </Cell>
  );
};
